import React, {
	useContext
} from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from '../../i18n/i18n';
import { DataContext } from "../../store/DataProvider";
import ReactLanguageSelect from 'react-languages-select';

export default function HeaderView() {
	const { t } = useTranslation();
	const context = useContext(DataContext)
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng, () => { context.reload() });
	}

	return (
		<header>
			<div className="row desktop_div">
				<div className='col-3 row'>
					<div className="nav-link">
						<Link to="/">{t('main_menu.home')}</Link>
					</div>
					<div className="nav-link">
						<Link to="/lists">{t('main_menu.lists')}</Link>
					</div>
					<div className="nav-link">
						<Link to="/practices">{t('main_menu.practices')}</Link>
					</div>
					<div className="nav-link">
						<Link to="/rules">{t('main_menu.rules')}</Link>
					</div>
					<div className="nav-link">
						<Link to="/search">{t('main_menu.search')}</Link>
					</div>
					<div className="nav-link float-right">
						<Link to="/contact">{t('main_menu.contact')}</Link>
					</div>
				</div>
				<div className='col-3'>
					<ReactLanguageSelect
					defaultLanguage="de"
					languages={["de", "en"]}
					names={"local"}
					customLabels={{"en": "English", "de": "Deutsch"}}
					showSelectedLabel={true}
					showOptionLabel={true}
					selectedSize={14}
					onSelect={changeLanguage} />
					{/*
					<button onClick={() => changeLanguage('de')}>de</button>
					<button onClick={() => changeLanguage('en')}>en</button>
					*/}
				</div>
			</div>

		</header>
	)
}